import React, {useEffect} from 'react';
import { Modal, Backdrop, Fade, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import { fetchPdfBlob } from '../api/fileAPI';

interface ProtectedFileModalProps {
  open: boolean;
  onClose: () => void;
  companyId: string;
  folderId: string;
  fileName: string;
}

const ProtectedFileModal: React.FC<ProtectedFileModalProps> = ({ open, onClose, companyId, folderId, fileName }) => {

  const [pdfUrl, setPdfUrl] = React.useState<string | null>(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  useEffect(() => {
    if (!open) return;

    const loadPdf = async () => {
      try {
        const blob = await fetchPdfBlob(companyId, folderId, fileName);
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (err) {
        console.error('Error loading PDF:', err);
      }
    };

    loadPdf();

    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [open, companyId, folderId, fileName]);


  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            height: '80%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            outline: 'none',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">{fileName}</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: 1, mt: 2, overflow: 'hidden' }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              {pdfUrl && <Viewer fileUrl={pdfUrl} />}
            </Worker>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ProtectedFileModal;